import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ContractItem } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { WistaAMSTypes } from 'src/app/wista-ams-types';

@Component({
  selector: 'app-transform-issue-items-summary-dialog',
  templateUrl: './transform-issue-items-summary-dialog.component.html',
  styleUrls: ['./transform-issue-items-summary-dialog.component.css']
})
export class TransformIssueItemsSummaryDialogComponent implements OnDestroy, OnInit {

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ContractItem[],
    private _ref: MatDialogRef<TransformIssueItemsSummaryDialogComponent>,
    private _dataService: DataService,
    private _router: Router,
  ) { }

  close(){
    this._ref.close();
  }

  navigateToContract(contractId: number){
    this._dataService.resolve(WistaAMSTypes.Contract, contractId, () => {
      this._router.navigate(["/edit-contract", contractId]);
      this.close();
    }, true);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
  }

}
